import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { UiHelper } from '@helpers/ui.helper';
import { ApiService } from '@services/api.service';

interface ITopLeagues {
  CategoryId: number;
  ExtensionData: any;
  IsoName: string;
  TournamentId: number;
  TournamentName: string;
  TournamentSportEventCount: number;
}
@Component({
  selector: 'fav-tournaments',
  templateUrl: '../sharedTemplates/fav-tournaments.component.html',
})
export class FavTournaments implements OnInit, OnDestroy {
  topLeaguesData: Array<ITopLeagues> = [];
  private subscriptionsToStopOnDestroy: Subscription[] = [];
  isOpenLeagueMenu = true;

  constructor(private _uiHelper: UiHelper, private _DataHelper: DataHelper, private _changeDetection: ChangeDetectorRef) {}

  favTournaments = [];
  ngOnInit() {
    this.subscriptionsToStopOnDestroy.push(
      this._uiHelper.favTournamentListener.subscribe(s => {
        this.favTournaments = s;
        this._changeDetection.detectChanges();
        //console.log("_changeDetection", this.favTournaments);
      })
    );
    this.favTournaments = this._uiHelper.favTournaments;
  }

  toggleLeagueMenu() {
    this.isOpenLeagueMenu = !this.isOpenLeagueMenu;
  }
  //click eventi bağlanacak
  selectedLeagueData = [];
  mainData = [];
  _dayFilter = 300;

  openLeague(tournament) {
    this.selectedLeagueData = [];

    const data = {
      TournamentName: tournament.tourname,
      TournamentId: tournament.tourid,
      CategoryId: tournament.catid,
      CategoryName: tournament.catname,
      SportId: 1,
      SportName: '',
    };

    this.selectedLeagueData.push(data);

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  unFav(item): void {
    this._uiHelper.favTournamentChanged(item);
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }
}
